import React, { useState } from "react";
import axios from "axios";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function CreateCoupan() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState("success");
  const [message, setMessage] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    code: "",
    discount_type: "",
    coupon_value: "",
    number_of_user: "",
    expiry_date: "",
    used_count: "",
    status: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { name, code, discount_type, coupon_value } = formData;

    if (!name || !code || !discount_type || !coupon_value) {
      setMessage("Please fill in all required fields.");
      setSnackbarType("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== "") {
          data.append(key, value);
        }
      });

      const token = localStorage.getItem("access_token");

      if (!token) {
        setMessage("Access token not found. Please log in again.");
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/create-coupon`,
        data,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === false) {
        setMessage(response.data.message || "Coupon creation failed.");
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      setMessage("Coupon created successfully.");
      setSnackbarType("success");
      setSnackbarOpen(true);

      setFormData({
        name: "",
        code: "",
        discount_type: "",
        coupon_value: "",
        number_of_user: "",
        expiry_date: "",
        used_count: "",
        status: "",
      });
    } catch (error) {
      console.error("Error creating coupon:", error);
      setMessage(
        error.response?.data?.message || "Failed to create coupon. Please try again."
      );
      setSnackbarType("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar absolute isMini />
      <MDBox mt={8} mb={8}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={10} lg={8}>
            <Card>
              <MDBox p={3}>
                <MDTypography
                  data-testid="create_coupan"
                  variant="h5"
                  fontWeight="medium"
                  mb={3}
                  component="h1"
                >
                  Create Coupon
                </MDTypography>

                <MDBox component="form" role="form" onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <MDInput
                        type="text"
                        label="Name"
                        name="name"
                        fullWidth
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MDInput
                        type="text"
                        label="Code"
                        name="code"
                        fullWidth
                        value={formData.code}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MDInput
                        type="text"
                        label="Discount Type"
                        name="discount_type"
                        fullWidth
                        value={formData.discount_type}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MDInput
                        type="number"
                        label="Coupon Value"
                        name="coupon_value"
                        fullWidth
                        value={formData.coupon_value}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MDInput
                        type="number"
                        label="Number of Users"
                        name="number_of_user"
                        fullWidth
                        value={formData.number_of_user}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <MDInput
                        type="date"
                        label="Expiry Date"
                        name="expiry_date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={formData.expiry_date}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MDInput
                        type="number"
                        label="Used Count"
                        name="used_count"
                        fullWidth
                        value={formData.used_count}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MDTypography
                        variant="button"
                        fontWeight="regular"
                        display="block"
                        mb={1}
                      >
                        Status
                      </MDTypography>
                      <select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <option value="">Select status</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </Grid>
                  </Grid>

                  <MDBox mt={4} mb={1}>
                    <MDButton
                      data-testid="submit"
                      variant="gradient"
                      color="info"
                      type="submit"
                      fullWidth
                    >
                      Create Coupon
                    </MDButton>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleSnackbarClose}
          severity={snackbarType}
          elevation={6}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </MuiAlert>
      </Snackbar>

      <Footer />
    </DashboardLayout>
  );
}

export default CreateCoupan;
